import { Link } from "react-router-dom";
import { LogoMarkStatic } from "@/components/LogoMark";

/**
 * Shared layout for /privacy, /terms, /compliance.
 * Sober, readable, footer note that this is not legal advice.
 */
export default function LegalDocumentLayout({ title, lastUpdated, children }) {
  return (
    <div className="min-h-screen bg-[#05070A] text-slate-200" data-testid="legal-page">
      <nav className="sticky top-0 z-50 glass-nav">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center" data-testid="legal-home">
            <LogoMarkStatic className="h-16 md:h-20" />
          </Link>
          <div className="flex items-center gap-5 text-sm text-slate-400">
            <Link to="/privacy" className="hover:text-slate-100" data-testid="legal-nav-privacy">Privacy</Link>
            <Link to="/terms" className="hover:text-slate-100" data-testid="legal-nav-terms">Terms</Link>
            <Link to="/compliance" className="hover:text-slate-100" data-testid="legal-nav-compliance">Compliance</Link>
          </div>
        </div>
      </nav>

      <article className="max-w-3xl mx-auto px-6 py-14">
        <div className="text-[11px] uppercase tracking-widest text-emerald-400 mb-2">Acquigine · Legal</div>
        <h1 className="font-heading text-4xl sm:text-5xl tracking-tight mb-3">{title}</h1>
        <div className="text-xs text-slate-500 mb-10">Last updated: {lastUpdated}</div>

        <div className="prose prose-invert prose-slate max-w-none legal-content">
          {children}
        </div>

        <div className="mt-16 border-t border-white/8 pt-6 text-xs text-slate-500 leading-relaxed">
          This page is provided for transparency and does not constitute legal advice. For account or compliance questions,
          contact <a href="mailto:legal@acquigine.com" className="text-emerald-400 hover:underline">legal@acquigine.com</a>.
        </div>
      </article>

      <footer className="border-t border-white/8 py-8 text-center text-xs text-slate-600">
        © {new Date().getFullYear()} Acquigine · <Link to="/" className="hover:text-slate-400">Home</Link>
      </footer>

      <style>{`
        .legal-content h2 { font-family: var(--font-heading, ui-sans-serif); font-size: 1.35rem; margin-top: 2.25rem; margin-bottom: 0.75rem; color: #f1f5f9; }
        .legal-content h3 { font-size: 1.05rem; margin-top: 1.5rem; margin-bottom: 0.4rem; color: #e2e8f0; }
        .legal-content h4 { font-size: 0.95rem; margin-top: 1.1rem; margin-bottom: 0.35rem; color: #cbd5e1; font-weight: 600; }
        .legal-content p, .legal-content li { color: #cbd5e1; line-height: 1.7; font-size: 0.925rem; }
        .legal-content ul { list-style: disc; padding-left: 1.5rem; margin: 0.75rem 0; }
        .legal-content ol { list-style: decimal; padding-left: 1.5rem; margin: 0.75rem 0; }
        .legal-content a { color: #34d399; }
        .legal-content strong { color: #f1f5f9; }
      `}</style>
    </div>
  );
}
